<template>
  <div class="box1">
    <div id="block"></div>
   
    <div class="text-box">
      <div class="title">
       AI大模型训练营2期
      </div>

      <div class="gradual-change-box">
        <div class="gradual-change">
          <i>·</i>70%主流大模型  <br />
          <i>·</i>通用型解决方案  <br />
          <i>·</i>8周即搞定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
 
  
  #block {
    width: 100%;
    height: 88px;
  }

  .text-box {
    width: 100%;
  height: 600px;
  background: url("../../../assets/coursePage/ai2/box1/banner.png") no-repeat;
  background-size: cover;
  background-position: center;

    padding-left: 68px;
    padding-top:106px;
    width: 100%;
    box-sizing: border-box;
    .title {
      margin-bottom: 64px;
      font-family: AlibabaPuHuiTiB;
      font-size: 72px;
      color: #051648;
      line-height: 68px;
      text-align: left;
      font-style: normal;
     
    }
  }

  .gradual-change-box {
    div {
     
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 34px;
      color: #051648;
      line-height: 68px;
      text-align: left;
      font-style: normal;
      i{
        margin-right: 5px;
        font-size: 34px;
      }
     
    }
  }
}
</style>